<div *ngIf="!simple" class="page-container" style="display: flex; align-items: flex-end">
  <div class="footer unity-padding-web unity-padding-h5-12">
    <div class="main-container">
      <div class="container footer-menu">
        <ng-container *ngIf="!isH5; else H5footer">
          <div class="content-box footer-menu-box">
            <ng-container *ngFor="let items of footerList; let idx = index">
              <!-- items.type !== 'Community' && -->
              <div *ngIf="items.type !== 'GamblingAddiction'" [ngClass]="['item' + (idx + 1)]">
                <h3>{{ convertFooterListTitle(items.name) | translate }}</h3>
                <ul>
                  <li *ngFor="let item of items.detail">
                    <a
                      class="onact96-a"
                      *ngIf="getIsLink(item.url); else routerPage"
                      [href]="item.url"
                      [target]="item.isBlank ? '_blank' : '_self'"
                    >
                      {{ item.title }}
                    </a>
                    <ng-template #routerPage>
                      <span class="onact96-not" (click)="jumpToPage(item.url, item.isBlank)">
                        @if (items.type !== 'Community') {
                          {{ item.title }}
                        } @else {
                          {{ item.url }}
                        }
                      </span>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </ng-container>

            <ng-container *ngTemplateOutlet="footerRight"></ng-container>
          </div>
        </ng-container>

        <ng-template #H5footer>
          <ul class="H5footer">
            <li class="item" *ngFor="let items of footerList; let i = index">
              <!-- items.type !== 'Community' &&  -->
              <div class="item-top onact96" (click)="onSelected(i)" *ngIf="items.type !== 'GamblingAddiction'">
                <p>{{ convertFooterListTitle(items.name) | translate }}</p>
                <div class="flag">{{ i === h5SelectedIndex ? '-' : '+' }}</div>
              </div>
              <ng-container *ngIf="i === h5SelectedIndex">
                <ul class="item-bottom">
                  <li *ngFor="let detail of items.detail">
                    <a
                      class="onact96-a"
                      *ngIf="getIsLink(detail.url); else routerPage"
                      [href]="detail.url"
                      [target]="detail.isBlank ? '_blank' : '_self'"
                      >{{ detail.title }}</a
                    >
                    <ng-template #routerPage>
                      <span class="onact96-not" (click)="jumpToPage(detail.url, detail.isBlank)">
                        @if (items.type !== 'Community') {
                          {{ detail.title }}
                        } @else {
                          {{ detail.url }}
                        }
                      </span>
                    </ng-template>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
          <ng-container *ngTemplateOutlet="footerRight"></ng-container>
        </ng-template>
      </div>

      <div class="container">
        <hr class="solid" />
      </div>

      <div class="container footer-sign">
        <div class="logo-container">
          <div class="logo-panel">
            <img src="assets/images/media/brand/pubs-logo.png" alt="pubs-logo" />
          </div>

          <div class="social-panel">
            <p class="social-wording">{{ 'follow_us_on' | translate }}</p>
            <div class="icon-panel">
              <ul class="icon-ul">
                @for (list of communityList.detail; track list.id) {
                  <li class="icon-li">
                    <a [href]="list.url" target="_blank" rel="noopener noreferrer">
                      @if (list.url.includes(FooterIconUrl.Telegram)) {
                        <ng-container *ngTemplateOutlet="telegramSvg"></ng-container>
                      }
                      @if (list.url.includes(FooterIconUrl.Facebook)) {
                        <ng-container *ngTemplateOutlet="facebookSvg"></ng-container>
                      }
                      @if (list.url.includes(FooterIconUrl.Instagram)) {
                        <ng-container *ngTemplateOutlet="instagramSvg"></ng-container>
                      }

                      @if (list.url.includes(FooterIconUrl.Youtube)) {
                        <ng-container *ngTemplateOutlet="youtubeSvg"></ng-container>
                      }
                      @if (list.url.includes(FooterIconUrl.X)) {
                        <ng-container *ngTemplateOutlet="xSvg"></ng-container>
                      }
                      @if (list.url.includes(FooterIconUrl.Discord)) {
                        <ng-container *ngTemplateOutlet="discordSvg"></ng-container>
                      }
                    </a>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>

        <div class="content-box">
          <p *ngIf="isOfficialSite">
            {{ disclaimer }}
          </p>

          <p>{{ 'copyright_2026_pubs_all_rights_reserved' | translate }}</p>
        </div>
      </div>
      <div class="container license-box">
        <div
          *ngIf="isOfficialSite"
          id="dlag-9bd36c32-a014-44a5-8268-d67f6c8748b0"
          data-dlag-seal-id="9bd36c32-a014-44a5-8268-d67f6c8748b0"
          data-dlag-image-type="basic-large"
        ></div>

        <i class="fi-age18"></i>
      </div>
      <div class="container">
        <div class="warning-wording">{{ 'gambling_can_be_addictive_play_responsibly' | translate }}</div>
      </div>
    </div>
  </div>
</div>

<ng-template #footerRight>
  <div class="footer-right" [ngClass]="['item' + (footerList.length + 1), isH5 ? 'h5-footer-right' : '']">
    <div class="row">
      <div class="community">
        <cs-select [(value)]="selectedLang" [options]="countries" (valueChange)="selectLang(selectedLang)"></cs-select>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #facebookSvg>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 22" fill="none">
    <g clip-path="url(#clip0_5643_25360)">
      <path
        d="M21 11.2666C21 5.46766 16.2989 0.766602 10.5 0.766602C4.70106 0.766602 0 5.46766 0 11.2666C0 16.1907 3.39024 20.3226 7.96362 21.4575V14.4754H5.79852V11.2666H7.96362V9.88396C7.96362 6.31018 9.58104 4.6537 13.0897 4.6537C13.755 4.6537 14.9029 4.78432 15.3724 4.91452V7.82302C15.1246 7.79698 14.6941 7.78396 14.1595 7.78396C12.4379 7.78396 11.7726 8.43622 11.7726 10.1318V11.2666H15.2023L14.6131 14.4754H11.7726V21.6897C16.9718 21.0618 21.0004 16.635 21.0004 11.2666H21Z"
        fill="#0866FF"
      />
      <path
        d="M14.6124 14.4754L15.2017 11.2666H11.7719V10.1317C11.7719 8.43621 12.4372 7.78395 14.1588 7.78395C14.6935 7.78395 15.124 7.79697 15.3718 7.82301V4.91451C14.9022 4.78389 13.7543 4.65369 13.0891 4.65369C9.58037 4.65369 7.96295 6.31017 7.96295 9.88395V11.2666H5.79785V14.4754H7.96295V21.4575C8.77523 21.6591 9.62489 21.7666 10.4993 21.7666C10.9298 21.7666 11.3545 21.7401 11.7715 21.6897V14.4754H14.612H14.6124Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5643_25360">
        <rect width="21" height="21" fill="white" transform="translate(0 0.766602)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #telegramSvg>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.9387 4.64121L19.6187 19.9162C19.3687 20.9942 18.7187 21.2622 17.7867 20.7542L12.7287 17.1172L10.2877 19.4072C10.1662 19.56 10.0115 19.6831 9.83519 19.7669C9.65889 19.8508 9.46579 19.8933 9.27069 19.8912L9.63369 14.8652L19.0087 6.60021C19.4167 6.24521 18.9206 6.04921 18.3746 6.40021L6.78469 13.5202L1.79464 11.9962C0.709644 11.6652 0.689644 10.9372 2.02069 10.4292L21.5377 3.09321C22.4427 2.76821 23.2337 3.29521 22.9387 4.64121Z"
      fill="#1296DB"
    />
  </svg>
</ng-template>
<ng-template #instagramSvg>
  <svg class="instagram-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23">
    <path
      d="M10.501 2.24935C13.3045 2.24935 13.637 2.26035 14.7447 2.31352C17.5902 2.44918 18.9194 3.8636 19.0489 6.8226C19.0996 7.98218 19.1092 8.33052 19.1092 11.2675C19.1092 14.2054 19.0987 14.5529 19.0489 15.7124C18.9185 18.6687 17.5929 20.0859 14.7447 20.2215C13.637 20.2747 13.3062 20.2857 10.501 20.2857C7.69748 20.2857 7.36498 20.2747 6.2581 20.2215C3.4056 20.0849 2.08348 18.6641 1.95398 15.7115C1.90323 14.5519 1.89273 14.2045 1.89273 11.2666C1.89273 8.3296 1.9041 7.98218 1.95398 6.82168C2.08435 3.8636 3.40998 2.44827 6.2581 2.3126C7.36585 2.26035 7.69748 2.24935 10.501 2.24935ZM10.501 0.266602C7.64935 0.266602 7.29235 0.279435 6.17235 0.332602C2.3591 0.515935 0.239852 2.73243 0.0648516 6.73094C0.0132266 7.90519 0.000976562 8.27919 0.000976562 11.2666C0.000976562 14.254 0.0132266 14.6289 0.0639766 15.8023C0.238977 19.7971 2.35473 22.0173 6.17148 22.2006C7.29235 22.2538 7.64935 22.2666 10.501 22.2666C13.3526 22.2666 13.7105 22.2538 14.8305 22.2006C18.6402 22.0173 20.7647 19.8008 20.9371 15.8023C20.9887 14.6289 21.001 14.254 21.001 11.2666C21.001 8.27919 20.9887 7.90519 20.938 6.73185C20.7665 2.74068 18.6481 0.516852 14.8314 0.333518C13.7105 0.279435 13.3526 0.266602 10.501 0.266602ZM10.501 5.6181C7.52335 5.6181 5.10923 8.14718 5.10923 11.2666C5.10923 14.386 7.52335 16.916 10.501 16.916C13.4786 16.916 15.8927 14.3869 15.8927 11.2666C15.8927 8.14718 13.4786 5.6181 10.501 5.6181ZM10.501 14.9333C8.5681 14.9333 7.00098 13.2924 7.00098 11.2666C7.00098 9.24168 8.5681 7.59994 10.501 7.59994C12.4339 7.59994 14.001 9.24168 14.001 11.2666C14.001 13.2924 12.4339 14.9333 10.501 14.9333ZM16.1062 4.07535C15.4097 4.07535 14.8454 4.6666 14.8454 5.39535C14.8454 6.1241 15.4097 6.71535 16.1062 6.71535C16.8019 6.71535 17.3654 6.1241 17.3654 5.39535C17.3654 4.6666 16.8019 4.07535 16.1062 4.07535Z"
      fill="#FAFFFE"
    />
  </svg>
</ng-template>
<ng-template #youtubeSvg>
  <svg class="youtube-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23" fill="none">
    <path
      d="M17.1641 3.18526C14.0106 2.95976 6.98698 2.96068 3.83785 3.18526C0.427977 3.42909 0.0263516 5.58693 0.000976562 11.2666C0.0263516 16.9362 0.424477 19.1032 3.83785 19.3479C6.98785 19.5725 14.0106 19.5734 17.1641 19.3479C20.574 19.1041 20.9756 16.9463 21.001 11.2666C20.9756 5.59701 20.5775 3.43001 17.1641 3.18526ZM7.87598 14.9333V7.59993L14.876 11.2602L7.87598 14.9333Z"
      fill="#FAFFFE"
    />
  </svg>
</ng-template>
<ng-template #xSvg>
  <svg class="x-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
    <g clip-path="url(#clip0_5643_25371)">
      <path
        d="M12.4979 9.22907L20.3156 0.141602H18.463L11.6749 8.03212L6.25324 0.141602H0L8.19861 12.0735L0 21.6031H1.85265L9.02109 13.2704L14.7468 21.6031H21L12.4974 9.22907H12.4979ZM9.96039 12.1786L9.1297 10.9904L2.52019 1.53625H5.36576L10.6997 9.16609L11.5304 10.3542L18.4639 20.2719H15.6183L9.96039 12.179V12.1786Z"
        fill="#FAFFFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5643_25371">
        <rect width="21" height="21.4725" fill="white" transform="translate(0 0.141602)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #discordSvg>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_11992_266)">
      <path
        d="M15.3785 3C15.144 3.41199 14.9334 3.8382 14.742 4.27387C12.9232 4.00395 11.0709 4.00395 9.24729 4.27387C9.06063 3.8382 8.84523 3.41199 8.61072 3C6.902 3.28888 5.23636 3.79558 3.65689 4.51065C0.526643 9.09945 -0.320532 13.5698 0.100668 17.9787C1.93381 19.3189 3.98715 20.3417 6.17448 20.9953C6.66747 20.3417 7.10303 19.6456 7.47636 18.9211C6.76798 18.6606 6.08354 18.3339 5.42782 17.955C5.60012 17.8319 5.76765 17.704 5.93038 17.5809C9.77378 19.371 14.225 19.371 18.0732 17.5809C18.236 17.7135 18.4035 17.8414 18.5758 17.955C17.9201 18.3386 17.2356 18.6606 16.5225 18.9258C16.8958 19.6504 17.3313 20.3465 17.8243 21C20.0116 20.3465 22.0649 19.3283 23.8982 17.9882C24.3959 12.8737 23.0462 8.44119 20.3323 4.51539C18.7577 3.80032 17.092 3.29361 15.3833 3.00947L15.3785 3ZM8.01242 15.2652C6.83022 15.2652 5.84902 14.2044 5.84902 12.8927C5.84902 11.5809 6.79192 10.5154 8.00765 10.5154C9.22337 10.5154 10.1902 11.5856 10.171 12.8927C10.1519 14.1997 9.21858 15.2652 8.01242 15.2652ZM15.9864 15.2652C14.7994 15.2652 13.8278 14.2044 13.8278 12.8927C13.8278 11.5809 14.7707 10.5154 15.9864 10.5154C17.2021 10.5154 18.1642 11.5856 18.145 12.8927C18.1259 14.1997 17.1925 15.2652 15.9864 15.2652Z"
        fill="#5865F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_11992_266">
        <rect width="24" height="18" fill="white" transform="translate(0 3)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
